import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { FormData, saveWellTest } from './addWellTestService';

interface AddWellTestState {
  formData: FormData;
  isSubmitting: boolean;
  submitSuccess: boolean;
  submitError: string | null;
}

const initialState: AddWellTestState = {
  formData: {
    id: 0,
    liquidFlowrate: '',
    waterCut: '',
    totalGasOilRatio: '',
    wellheadPressure: '',
    wellheadTemperature: '',
    casingPressure: '',
    flowlinePressure: '',
    productionChokePosition: '',
    pumpIntakePressure: '',
    pumpIntakeTemperature: '',
    pumpFrequency: '',
    pumpDischargePressure: '',
    waterDensity: '',
    comment: '',
    enabled: true,
    date: '',
    wellId: null,
    methodOfProduction: '',
    reservoirPressure: '',
  },
  isSubmitting: false,
  submitSuccess: false,
  submitError: null,
};

// Async thunk to save well test
export const saveWellTestAsync = createAsyncThunk(
  'addWellTest/saveWellTest',
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await saveWellTest(formData);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to save well test');
    }
  },
);

const addWellTestSlice = createSlice({
  name: 'addWellTest',
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<Partial<FormData>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveWellTestAsync.pending, (state) => {
        state.isSubmitting = true;
        state.submitSuccess = false;
        state.submitError = null;
      })
      .addCase(saveWellTestAsync.fulfilled, (state) => {
        state.isSubmitting = false;
        state.submitSuccess = true;
        state.submitError = null;
      })
      .addCase(saveWellTestAsync.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitSuccess = false;
        state.submitError = action.payload as string;
      });
  },
});

export const { setFormData, resetState } = addWellTestSlice.actions;

export default addWellTestSlice.reducer;
